define('AwaLabs.LayoutClass', [
], function AwaLabsLayoutClass(
) {
    'use strict';

    return {
        addClassToLayout: function addClassToLayout(Layout, view) {
            Layout.$('#layout').removeClass().addClass(this.layoutClass).addClass('sec_' + view.template.Name);
        },
        mountToApp: function mountToApp(application) {
            var Layout = application.getLayout();
            var self = this;
            Layout.once('afterAppendView', function afterAppendViewOnce(view) {
                self.layoutClass = Layout.$('#layout').attr('class');
                self.addClassToLayout(Layout, view);
                Layout.on('afterAppendView', function afterAppendViewOn(view2) {
                    if (!view2.inModal) {
                        self.addClassToLayout(Layout, view2);
                    }
                });
            });
        }
    };
});
